import { Navigate, useLocation } from 'react-router'
import { UrgencyPriorityOptionDTO, UrgencySexOptionDTO } from '../../../dto/urgencySummary/UrgencySummaryDTO'
import { isUrgencyDetailRouteState } from '../urgencyDetailState'
import UrgencyDetailPage from './UrgencyDetailPage'

interface UrgencyDetailViewProps {
  /** Ruta del resumen, a donde se vuelve. */
  basePath: string
  /** Opciones del filtro de sexo (vienen de `/options`, que ya se pidió con el resumen). */
  sexes: UrgencySexOptionDTO[]
  /** Códigos de triaje para el filtro «Código». */
  priorities: UrgencyPriorityOptionDTO[]
}

/**
 * Detalle de atenciones de urgencia: página completa a la que se llega con `navigate(..., { state })`.
 * Los filtros no van en la URL, así que si se recarga sin `state` se vuelve al resumen.
 */
export default function UrgencyDetailView({ basePath, sexes, priorities }: UrgencyDetailViewProps) {
  const { state } = useLocation()

  if (!isUrgencyDetailRouteState(state)) {
    return <Navigate to={basePath} replace />
  }
  return <UrgencyDetailPage state={state} basePath={basePath} sexes={sexes} priorities={priorities} />
}
